import { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useRegisterMutation } from "../model/authApi";
import { setAuth } from "../model/authSlice";
import { useAppDispatch } from "@/shared/hooks";
import { validateEmail, validatePassword, validateFullname } from "../lib/validation";
import fondLogo from "@/assets/fond_start1.png";
import styles from "./AuthPage.module.scss";

export const RegisterPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullname, setFullname] = useState("");
  const [errors, setErrors] = useState<{ email?: string; password?: string; fullname?: string; general?: string }>({});
  const [register, { isLoading }] = useRegisterMutation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setErrors({});

    if (!validateEmail(email)) {
      setErrors({ email: "Invalid email address" });
      return;
    }

    const passwordValidation = validatePassword(password);
    if (!passwordValidation.valid) {
      setErrors({ password: passwordValidation.error });
      return;
    }

    const fullnameValidation = validateFullname(fullname);
    if (!fullnameValidation.valid) {
      setErrors({ fullname: fullnameValidation.error });
      return;
    }

    try {
      const result = await register({ email, password, fullname }).unwrap();
      
      // Сохраняем токены в Redux store и localStorage
      dispatch(setAuth({ 
        token: result.access_token, 
        refreshToken: result.refresh_token,
        userId: result.user_id 
      }));
      
      // Даем время на обновление Redux store и localStorage перед редиректом
      await new Promise(resolve => setTimeout(resolve, 150));
      
      // Редиректим на /quiz для прохождения стартовой анкеты
      navigate("/quiz", { replace: true });
    } catch (err: any) {
      setErrors({ general: err?.data?.detail || "Registration failed" });
    }
  };

  return (
    <div className={styles.authPage}>
      <div className={styles.authContainer}>
        <h1 className={styles.title}>Регистрация</h1>
        <form onSubmit={handleSubmit} className={styles.form}>
          {errors.general && <div className={styles.error}>{errors.general}</div>}
          <div className={styles.field}>
            <label htmlFor="fullname">Имя</label>
            <input
              id="fullname"
              type="text"
              value={fullname}
              onChange={(e) => setFullname(e.target.value)}
              className={errors.fullname ? styles.inputError : ""}
              required
            />
            {errors.fullname && <span className={styles.fieldError}>{errors.fullname}</span>}
          </div>
          <div className={styles.field}>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={errors.email ? styles.inputError : ""}
              required
            />
            {errors.email && <span className={styles.fieldError}>{errors.email}</span>}
          </div>
          <div className={styles.field}>
            <label htmlFor="password">Пароль</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={errors.password ? styles.inputError : ""}
              required
            />
            {errors.password && <span className={styles.fieldError}>{errors.password}</span>}
          </div>
          <button type="submit" className={styles.submitButton} disabled={isLoading}>
            {isLoading ? "Регистрация..." : "Зарегистрироваться"}
          </button>
        </form>
        <div className={styles.footer}>
          <span>Уже есть аккаунт? </span>
          <a href="/login" className={styles.link}>
            Войти
          </a>
        </div>
        <div style={{ textAlign: "center", marginTop: "32px" }}>
          <img src={fondLogo} alt="FitKeep Logo" style={{ width: "100px", height: "auto" }} />
        </div>
      </div>
    </div>
  );
};



